import React from 'react';
import { ThemeProvider } from 'styled-components';
import { TextLinkInline } from '@nebula/text-link';
import nebulaTheme from '@nebula/theme';
import { openAuthenticatedUrl } from '@ecs-uk/web-common-mobile-view-helpers';

import { getEnv } from '../../Context/env';
import {
  ThankYouContainer,
  ThankYouSubtitle,
  ThankYouTitle,
  ThankYouButton,
  MainContent,
  ThankYouPageContainer,
  ThankYouLinkTile,
} from './index.styles';

type ThankYouNonCoolingOffPeriodProps = {
  subscriptionName: string;
  formattedNextBillingDate: string;
  onGoHome: () => void;
  isWebview?: boolean;
};

import usePageView from '../../../hooks/usePageView';

const PAGE_NAME = 'ProdMoveCancellationSuccessPage';

export default function ThankYouNonCoolingOffPeriod({
  subscriptionName,
  formattedNextBillingDate,
  onGoHome,
  isWebview = false,
}: Readonly<ThankYouNonCoolingOffPeriodProps>) {
  const env = getEnv();
  const openExternalLink = (url: string) => (event: React.SyntheticEvent<HTMLAnchorElement, Event>) => {
    if (isWebview) {
      event.preventDefault();
      openAuthenticatedUrl(new URL(url));
      return;
    }

    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

    if (!newWindow) {
      return;
    }

    event.preventDefault();
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  usePageView(PAGE_NAME);

  const termsUrl = `${env.REACT_APP_EXPERIAN_URL}/consumer/terms.html`;
  const privacyUrl = `${env.REACT_APP_EXPERIAN_URL}/consumer/privacy.html`;

  return (
    <ThemeProvider theme={nebulaTheme}>
      <ThankYouPageContainer $isWebview={isWebview}>
        <ThankYouContainer data-testid="thank-you-container">
          <MainContent>
            <ThankYouTitle>{subscriptionName} subscription cancelled</ThankYouTitle>
            <ThankYouSubtitle>
              No further payments will be taken, and you will be moved a free Experian account on{' '}
              {formattedNextBillingDate}.{' '}
              <ThankYouLinkTile>
                Your account is still covered by the same{' '}
                <TextLinkInline href={termsUrl} onClick={openExternalLink(termsUrl)}>
                  Terms &amp; Conditions
                </TextLinkInline>{' '}
                and{' '}
                <TextLinkInline href={privacyUrl} onClick={openExternalLink(privacyUrl)}>
                  Privacy Policy
                </TextLinkInline>{' '}
                you originally agreed to.
              </ThankYouLinkTile>
            </ThankYouSubtitle>
            <ThankYouButton buttonKind="primaryMagenta" label="Go to home screen" onClick={onGoHome}></ThankYouButton>
          </MainContent>
        </ThankYouContainer>
      </ThankYouPageContainer>
    </ThemeProvider>
  );
}
